<script setup>
import { emitter } from "@plugins/mitt";

const props = defineProps({
  room: {
    type: Object,
    required: true,
  },
});

const emits = defineEmits(["onRoomClicked"]);

const roomType = computed(() => {
  if (props.room.isBroadcasting && props.room.streamUID) {
    return "roomLive";
  } else if (props.room.online) {
    return "roomHostOnline";
  }
  return "roomNormal";
});

const clickRoom = () => {
  console.log("clickRoom", props.room);
  emits("onRoomClicked", props.room);
  emitter.emit("openHubDialog", props.room);
};
</script>

<template>
  <div
    class="room"
    :class="{
      'room-live': roomType === 'roomLive',
      'room-host-online': roomType === 'roomHostOnline',
      'room-normal': roomType === 'roomNormal',
    }"
    @click.prevent="clickRoom"
  >
    <!-- <div class=""> -->
    <div class="tw-flex tw-flex-col tw-h-full">
      <div class="tw-grid tw-grid-cols-3 tw-gap-2">
        <div>
          <user-avatar :imageUrl="room.imageUrl" class="tw-w-full" />
        </div>

        <div class="tw-col-span-2 tw-text-xs">
          <div class="tw-col-span-2 tw-font-bold tw-text-xs">{{ room.roomHostName }}:</div>
          <!-- $ nlink -x: -->
          <div class="tw-col-span-2 tw-font-bold tw-text-xs">{{ room.title }}</div>
        </div>
      </div>

      <v-spacer></v-spacer>

      <div class="tw-text-xs tw-italic tw-flex tw-justify-between">
        <div class="online">
          <span class="dot-online"></span>

          {{ Object.keys(room.participants).length }}
        </div>

        <div>
          {{ room.visitCount ? formatNumber(room.visitCount) : 0 }}
          {{ room.visitCount > 1 ? " visits" : " visit" }}
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<style scoped lang="postcss">
.online {
  @apply tw-flex tw-items-center;
  line-height: 0.875rem;
}
.dot-online {
  margin-right: 1.5px;
  width: 8px;
  height: 8px;
  background-color: #4caf50;
  border-radius: 999px;
  display: inline-block;
  border: 1px solid #fff;
}

.room {
  @apply tw-aspect-[207/106] tw-max-w-[207px] tw-w-full tw-bg-black tw-bg-cover tw-bg-center tw-bg-no-repeat tw-relative tw-rounded-2xl tw-p-3 tw-box-border tw-cursor-pointer;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  &.room-live {
    border: 4px solid #ff003d;
  }
  &.room-host-online {
    border: 4px solid #18ba77;
  }
  &.room-normal {
    border: 4px solid #db00ff;
  }
}

.room-participants {
  @apply tw-rounded-full tw-flex tw-items-center tw-gap-1 tw-h-8 tw-px-2;
  background: linear-gradient(
    180deg,
    rgba(255, 120, 120, 0.5) 0%,
    rgba(238, 165, 244, 0.5) 100%
  );
}

.room-info {
  @apply tw-rounded-2xl tw-p-2 tw-flex tw-gap-2;
  background: linear-gradient(
    180deg,
    rgba(255, 120, 120, 0.5) 0%,
    rgba(238, 165, 244, 0.5) 100%
  );
}
</style>
